module.exports = __webpack_public_path__ + "static/img/logowhite.7e6d806.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logowhite.png
// module id = qIWX
// module chunks = 1